import { Link } from 'react-router-dom';
import { ProductImage } from '../../ui/ProductImage';
import { AddButton } from '../shared/AddButton';
import { useCatalog } from '../../contexts/CatalogContext';
import { creators } from '../../data/creators';
import { founder } from '../../data/content';
import { shopLabels } from '../../data/shopLabels';
import { euro } from '../../core/format/currency';
import { isSoldOut } from '../../core/rules/stock';
import { sectionHeading } from '../../ui/sections';

/**
 * Vaste cliënten en hun favoriete product, met hun code. Staat op Over
 * (docs/VORMGEVING.md §3): het is sociaal bewijs bij het verhaal van Sarah. Een creator zonder
 * bestaand product valt weg; de lijst zelf staat in Instellingen › Cadeaus & codes.
 */
export function CreatorRail() {
  const {
    productById
  } = useCatalog();
  const picks = creators.flatMap(c => {
    const pick = productById(c.pickId);
    return pick ? [{
      creator: c,
      pick
    }] : [];
  });
  if (picks.length === 0) return null;
  return <section className="bg-sand py-20 sm:py-24 lg:py-32" aria-labelledby="collectief" data-id="element-5596" data-mp="1h0d3ncy6h43a">
      <div className="mx-auto max-w-content px-6 lg:px-10" data-id="element-5597" data-mp="1lz6j3ax0z563">
        <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-5598" data-mp="1lxlqhqu9twav">
          <h2 id="collectief" className={`max-w-2xl ${sectionHeading} text-ink`} data-id="element-5599" data-mp="1qqy1gy6124l5">
            Wat zij dagelijks gebruiken
          </h2>
          <p className="max-w-sm text-[16px] leading-relaxed text-muted" data-id="element-5600" data-mp="1vo6opd618yt9">
            Geen betaalde posts. Dit zijn de routines van vaste cliënten van {founder.firstName}, met hun code voor jou.
          </p>
        </div>

        <ul className="mt-14 grid gap-8 md:grid-cols-3" data-id="element-5601" data-mp="17zeyusfx0sjn">
          {picks.map(({
          creator: c,
          pick
        }) => {
          const soldOut = isSoldOut(pick);
          const path = `/webshop/${pick.id}`;
          return <li key={c.handle} className="h-full" data-id="element-5602" data-mp="2jf3nrpcqc1n3">
                <article className="flex h-full flex-col bg-shell" aria-label={c.name} data-id="element-5603" data-mp="2jgn4fh2asepe">
                  <img src={c.image} alt={c.name} loading="lazy" className="aspect-[4/5] w-full object-cover" data-id="element-5604" data-mp="2necgcqw19th2" />
                  <div className="flex flex-1 flex-col p-6" data-id="element-5605" data-mp="odibf68j3e7c">
                    <h3 className="font-display text-xl font-normal text-ink" data-id="element-5606" data-mp="jb9k0ebb0k7c">{c.name}</h3>
                    <p className="mt-0.5 text-[13px] text-muted" data-id="element-5607" data-mp="xb12ar8usmr5">
                      {c.handle} · {c.role}
                    </p>
                    <blockquote className="mt-4 text-[15px] leading-relaxed text-muted" data-id="element-5608" data-mp="sdsg8fkl3ykm">“{c.quote}”</blockquote>

                    <div className="mt-auto pt-6" data-id="element-5609" data-mp="4lbw7zhadwio">
                      <div className="flex items-center gap-3 border-t border-line pt-4" data-id="element-5610" data-mp="murtnp9304y">
                        {/* Dezelfde bestemming als de naam ernaast: niet dubbel in de tabvolgorde. */}
                        <Link to={path} className="shrink-0" tabIndex={-1} aria-hidden="true" data-id="element-5611" data-mp="9m9jgqh5lgr1">
                          <ProductImage src={pick.image} alt="" className="h-14 w-12 shrink-0 p-1" data-id="element-5612" data-mp="3i1jcza6z9dn7" />
                        </Link>
                        <div className="min-w-0 flex-1" data-id="element-5613" data-mp="3d2ovqconrx57">
                          <p className="text-[13px] text-clay" data-id="element-5614" data-mp="1skntli68d3x2">Haar keuze</p>
                          <Link to={path} className="block text-[15px] leading-snug text-ink transition-colors duration-150 ease-soft hover:text-clay" data-id="element-5615" data-mp="1xbw5qlyy33dx">
                            {pick.name}
                          </Link>
                          <p className="text-[13px] text-muted" data-id="element-5616" data-mp="1oisumkbrv2mg">
                            {euro(pick.price)}
                            {soldOut && <span className="text-clay" data-id="element-5617" data-mp="2cahs0f3gaha9"> · {shopLabels.soldOutShort}</span>}
                          </p>
                        </div>
                        <AddButton product={pick} data-id="element-5618" data-mp="22azae5b0j7ld" />
                      </div>
                      <p className="mt-3 text-[13px] text-muted" data-id="element-5619" data-mp="22d3byglfvuih">
                        Code <span className="text-ink" data-id="element-5620" data-mp="278inv2zvzgc9">{c.code}</span>: reisformaat cadeau bij je bestelling
                      </p>
                    </div>
                  </div>
                </article>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}